var option_default = {
  "option": "v1mTu",
  "user_choice": "KAxO6",
  "check": "ly-fL",
  "image": "Hs3t4",
  "input": "k2JSJ",
  "title": "FXDyW",
  "centered": "xyJDL",
  "with_result": "jl6kq",
  "list": "ELlBr",
  "with_image": "XWozd",
  "progress": "_9IzxV",
  "progress_value": "_39Tc9",
  "label": "qg6CQ",
  "cta": "_-4rbP",
  "adornment_icon": "XAMRr",
  "remove": "qsNr6",
  "removeButton": "DRNa6",
  "removeButtonIcon": "_770tN",
  "overlay": "_2Oypr",
  "shown": "xSZON",
  "dark": "MRlr5",
  "spinner": "_64t02",
  "spin": "_0qS0q"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
